<template>
  <div>
    <component
      v-if="userFetched"
      :is="'EditMaintenanceOrderForm'"
      :orderDetails="orderDetails"
      :orderId="orderId"
      :assignations="assignations"
      :statusOptions="assignationStatuses"
      :username="username"
      :user_id="user_id"
      :user_groups="user_groups"
      @refresh-order="handleRefreshOrder"
      :key="refreshKey"
    />
  </div>
</template>

<script>
import axios from 'axios'
import EditMaintenanceOrderForm from './EditMaintenanceOrderForm.vue'

export default {
  components: { EditMaintenanceOrderForm },
  data() {
    return {
      orderDetails: null,
      orderId: null,
      assignations: [],
      assignationStatuses: [],
      username: '',
      user_id: null,
      user_groups: [],
      permissions: [],
      userFetched: false,
      refreshKey: 0,
    }
  },
  async mounted() {
    this.orderId = this.$route.params.orderId
    this.loadPermissions()
    if (!this.canViewOrder) {
      this.$router.push({ name: 'MainPanel' })
      return
    }
    await this.fetchOrderDetails()
    await this.fetchAssignations()
    await this.fetchAssignationStatuses()
    await this.fetchCurrentUser()
  },
  computed: {
    canViewOrder() {
      return this.hasAnyPerm(['maintenance.view_order', 'ui_access_maintenance_workshop_card'])
    },
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    hasAnyPerm(perms) {
      if (!Array.isArray(perms) || perms.length === 0) return false
      return perms.some((perm) => this.hasPerm(perm))
    },
    async fetchOrderDetails() {
      const orderId = this.$route.params.orderId
      try {
        const apiDirectory = process.env.API_DIRECTORY
        const response = await axios.get(`${apiDirectory}/maintenance-orders/${orderId}/`)
        this.orderDetails = response.data
      } catch (error) {
        console.error('Failed to fetch maintenance order details:', error)
      }
    },
    async fetchAssignations() {
      const orderId = this.$route.params.orderId
      try {
        const apiDirectory = process.env.API_DIRECTORY
        const response = await axios.post(`${apiDirectory}/get-maintenance-assignations`, { maintenance_order: orderId })
        this.assignations = response.data
      } catch (error) {
        console.error('Failed to fetch maintenance assignations:', error)
      }
    },
    async fetchAssignationStatuses() {
      try {
        const apiDirectory = process.env.API_DIRECTORY
        const response = await axios.get(`${apiDirectory}/maintenance-assignation-statuses`)
        this.assignationStatuses = response.data
      } catch (error) {
        console.error('Failed to fetch assignation statuses:', error)
      }
    },
    fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      return axios
        .get(`${apiDirectory}/current-user/`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('authToken')}`,
          },
        })
        .then((response) => {
          this.user_groups = response.data.groups
          this.user_id = response.data.id
          this.userFetched = true
        })
        .catch((error) => {
          console.error('There was an error fetching the user data:', error)
        })
    },
    async handleRefreshOrder() {
      await Promise.all([
        this.fetchOrderDetails(),
        this.fetchAssignations(),
        this.fetchAssignationStatuses(),
        this.fetchCurrentUser(),
      ])
      this.refreshKey += 1
    },
  },
}
</script>
